import { z } from 'zod'

import { emptySelectOptionZod } from 'components/Select'
import { commonSchema } from 'features/globalSetup/forms/Prebid/Bidders/schemas/commonSchema'
import { WorkspaceBidderSlice } from 'features/globalSetup/pages/Prebid/Bidders/EditBidderPage/hooks/useGetWorkspaceBidder'
import { validateJSONSchema } from 'utils/json'
import { BidderSlice } from '../types'

export const editSchema = commonSchema.and(
  z.object({
    bidderConfig: z.string().superRefine(validateJSONSchema).default('{}'),
    bidderConfigEnabled: z.boolean().default(false),
  }),
)

export type EditSchema = z.infer<typeof editSchema>

export const editSchemaDefault = (workspaceBidder: WorkspaceBidderSlice): EditSchema => {
  const {
    accountType,
    bidCpmAdjustment,
    bidderCode,
    bidderConfig,
    bidderConfigEnabled,
    bidderSid,
    consentMode,
    priority,
    status,
    supplyChain,
  } = workspaceBidder

  return {
    accountType,
    bidCpmAdjustment,
    bidderCode,
    bidderConfig,
    bidderConfigEnabled,
    bidderId: emptySelectOptionZod<BidderSlice>(),
    bidderSid: bidderSid || '',
    consentMode,
    priority,
    status,
    supplyChain: supplyChain?.id ?? '',
  }
}
